module.exports = __webpack_public_path__ + "static/media/microsoft.8307ca44.svg";